import { gql } from '@apollo/client'

export const listStaffMembersForStoreQuery = gql`
  query ListStaffMembersForStoreQuery($storeId: String!, $extended: Boolean!) {
    staffMember {
      id
      staffMembers(storeId: $storeId) {
        id
        email
        firstName
        lastName
        profilePicture
        title
        personalEmail
        isStoreManager
        numberOfAssignedCustomers(storeId: $storeId) @include(if: $extended)
        numberOfActiveCustomers(storeId: $storeId) @include(if: $extended)
        offdates {
          fromDate
          toDate
        }
      }
    }
  }
`
